import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styles from './Button.module.css'

export const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    icon = false,
    iconLeft,
    iconRight,
    disabled = false,
    loading = false,
    type = 'button',
    href,
    onClick,
    className = '',
    children,
    ...rest
  },
  ref
) {
  const isBlocked = disabled || loading

  const classes = [
    styles.btn,
    styles[variant],
    styles[size],
    icon ? styles.icon : '',
    loading ? styles.loading : '',
    className,
  ].filter(Boolean).join(' ')

  const content = loading ? (
    <>
      {children}
      <span className={styles.spinner} aria-hidden="true" />
    </>
  ) : (
    <>
      {iconLeft}
      {children}
      {iconRight}
    </>
  )

  if (href) {
    return (
      <a
        {...rest}
        ref={ref}
        href={isBlocked ? undefined : href}
        className={classes}
        aria-disabled={isBlocked || undefined}
        aria-busy={loading || undefined}
        onClick={isBlocked ? (e) => e.preventDefault() : onClick}
      >
        {content}
      </a>
    )
  }

  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled}
      aria-busy={loading || undefined}
      onClick={loading ? undefined : onClick}
    >
      {content}
    </button>
  )
})

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger', 'link']),
  size: PropTypes.oneOf(['sm', 'md']),
  icon: PropTypes.bool,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}
